// Strips query params whose value is junk — 'undefined'/'null'/'none'/'nan'
// (any casing) or empty — so a bad upstream redirect can never leave e.g.
// ?e-msisdn=undefined or ?msisdn=undefined visible in the address bar.
// Runs once at app bootstrap (see main.js), before any page logic reads the
// query string, and rewrites the URL in place via history.replaceState.
const JUNK_VALUE = /^(undefined|null|none|nan)$/i;

export function sanitizeUrlParams() {
    if (typeof window === 'undefined' || !window.location) return;

    const url = new URL(window.location.href);
    let changed = false;

    for (const key of [...url.searchParams.keys()]) {
        const value = url.searchParams.get(key);
        if (!value || JUNK_VALUE.test(value.trim())) {
            url.searchParams.delete(key);
            changed = true;
        }
    }

    if (changed) {
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
}
